<app-bottom-sheet #sheet ariaLabel="تایید خروج از حساب کاربری" (closed)="onSheetClosed()">
	<ng-template #body>
		<ui-empty-state
			class="py-4"
			variant="error"
			iconName="kala-logout"
			title="خروج از حساب"
			description="آیا مایل به خروج از حساب کاربری خود هستید؟"
			data-cy="logout-confirm-text" />
	</ng-template>

	<ng-template #footer>
		<div class="flex w-full items-center gap-2 py-4" data-cy="logout-confirm-actions">
			<ui-button
				#confirmButton
				type="button"
				class="min-w-0 flex-1"
				variant="red"
				size="lg"
				extraButtonClasses="w-full"
				data-cy="logout-confirm-submit"
				label="تأیید"
				[loading]="signingOut()"
				[disabled]="signingOut()"
				(click)="onConfirm()" />
			<ui-button
				class="grow-0"
				variant="mute"
				size="lg"
				data-cy="logout-confirm-dismiss"
				label="انصراف"
				[disabled]="signingOut()"
				(click)="onDismiss()" />
		</div>
	</ng-template>
</app-bottom-sheet>
